import { Card, Grid, makeStyles, Typography, styled, Button, useTheme } from "@material-ui/core";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { loginUser } from "../../../actions/auth.action.entry";
import FullLoader from "../../../components/Loader/FullLoader.component";
import PageBackground from "../../../components/pageBackground.component";
import "./login.css";
import gseLogo from "../../../../src/assets/img/gseLogo.png";
// import vinkel from "../../assets/icons/ico_vinkel.png";
// import colfactura from "../../assets/icons/ico_colfactura.png";
// import firmaEmail from "../../assets/icons/ico_firmaemail.png";
// import firmaYa from "../../assets/icons/ico_firmaya.png";
// import cronoFirma from "../../assets/icons/ico_cronofirma.png";
// import firmaCentral from "../../assets/icons/ico_firmacentral.png";

const OwnButton = styled(Button)(({ theme }) => ({
  width: "173px",
  height: "46px",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: "36px",
  boxShadow: "0px 4px 4px #00000033",
  textTransform: "none",
  padding: 0,
  marginTop: "28px",
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.25)",
  },
}))

const useStyles = makeStyles((theme) => ({
    root: {
        // width:'500px',
        maxWidth: "700px",
        // height: '350px',
        maxHeight: "350px",
        padding: "70px",
        borderRadius: "10px",
        backgroundColor: "#F7F7F7",
    },
    rootCard: {
        width: "384px",
        height: "277px",
        padding: "28px 24px",
        borderRadius: "12px",
        backgroundColor: theme.InputUko?.backgroundColor || "#F7F7F7",
        boxSizing: "border-box",
        overflow: "hidden",
    },

    logo: {
        width: "230px",
        height: "54px",
        objectFit: "contain",
        marginBottom: "36px",
    },

    activateTitle: {
        fontSize: "20px",
        fontWeight: 700,
        color: theme.palette.primary.main,
        textAlign: "center",
        fontFamily: "'Mulish', sans-serif",
        width: "100%",
        lineHeight: "28px",
        margin: "0px 0px 15px",
    },

    buttonText: {
        fontSize: "18px",
        fontWeight: 700,
        textTransform: "none",
        letterSpacing: "0px",
        fontFamily: "'Mulish', sans-serif",
    },
    title: {
        fontSize: "18px",
    },
    titleExtra: {
        color: "#E45501",
        marginBottom: "28px",
    },
    cardApp: {
        width: "92px",
        height: "92px",
        cursor: "pointer",
        borderRadius: "10px",
        shadows: "0px 3px 6px #00000029",
        marginBottom: "10px",
        // marginLeft: '5px',
        // marginRight: '5px',
        border: "1px solid transparent",
        "&:hover": {
            border: "1px solid #009BDD",
        },
    },
    image: {
        width: "80px",
        height: "80px",
        padding: "5px",
        objectFit: "contain",
    },
}));

export const AvailableApps = ({ ...props }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const selectorAuth = useSelector(state => state.authReducer.getAuthenticationResponse)
    let history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [isNewUser] = useState(props.location?.state?.userData?.isNewUser);
    const theme = useTheme();

    useEffect(() => {
        if (!!selectorAuth) {
            if (!!selectorAuth.url && selectorAuth.url !== "") {
                window.open(selectorAuth.url, "_blank");
                setIsLoading(false)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectorAuth]);

    const handleClick = (app) => {
        if (app.mechanismAfterSetPass === 1) {
            window.open(app.landing, "_blank");
        } else {
            setIsLoading(true);
            dispatch(
                loginUser({ ...props.location.state.userData, appname: app.name }, history)
            )
        }
    };
    return (
        <div className="login">
            <PageBackground></PageBackground>
            {!isNewUser ? (
                <>
                    <Card className={classes.root}>
                        {isLoading ? <FullLoader
                            open={isLoading}
                            handleClose={() => { }}
                        /> : null}
                    <Grid container lg={12} justifyContent="center">
                        <Typography className={[classes.title, classes.titleExtra]}>{props.location?.state?.message}</Typography>
                        <Typography className={classes.title}>Recuerda que con tu usuario y contraseña, puedes</Typography>
                        <Typography className={classes.title}>ingresar a las siguientes aplicaciones, haz clic en la que desees:</Typography>
                        <Grid lg={10} container justifyContent="space-evenly" alignItems="stretch" style={{ marginTop: "40px" }}>
                            {props.location?.state?.apps.map((app) => {
                                return (
                                    <Card onClick={() => handleClick(app)} className={classes.cardApp} key={app.id}>
                                        <img className={classes.image} src={`icons/ico_${app.name.toLowerCase()}.png`} 
                                        alt={app.title} title={app.title}
                                        onError={(e) => { e.currentTarget.src = "icons/ico_ibuhoo.png"; }}></img>
                                    </Card>
                                );
                            })}
                        </Grid>
                    </Grid>
                    </Card>
                </>
            ): (
                <>  
                    <Card className={classes.rootCard}>
                        <Grid container direction="column" justifyContent="center" alignItems="center" style={{ height: "100%" }}>
                            <img
                                src={theme?.urlLogo?.urlSignIn || gseLogo}
                                alt="GSE Gestión de Seguridad Electrónica"
                                className={classes.logo}
                            />
                            <Typography className={classes.activateTitle}>¡Tu cuenta ha sido activada!</Typography>
                            <OwnButton
                                type="button"
                                onClick={() => history.push("/login")}
                            >
                                <Typography className={classes.buttonText}
                                    >
                                    Iniciar sesión
                                </Typography>
                            </OwnButton>
                        </Grid>
                    </Card>
                </>
            )}
        </div>
    );
};
